module.exports = __webpack_public_path__ + "static/media/m2.b46a93f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m2.mp4
// module id = +jEC
// module chunks = 1